module.exports = __webpack_public_path__ + "files/81c19ff276a3c3356550fd9818e842a1.png";